import { render } from "./EthiotelAmharicFAQs.vue?vue&type=template&id=1fa33413&scoped=true"
import script from "./EthiotelAmharicFAQs.vue?vue&type=script&lang=js"
export * from "./EthiotelAmharicFAQs.vue?vue&type=script&lang=js"

import "./EthiotelAmharicFAQs.vue?vue&type=style&index=0&id=1fa33413&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa33413"]])

export default __exports__